if (!customElements.get('mce-ink-cycle')) {
  customElements.define('mce-ink-cycle', class extends HTMLElement {
    connectedCallback() {
      this.frames = this.querySelector('[data-mce-ink-screen]');
      this.observer = new MutationObserver(() => this.syncModal());
      this.observer.observe(this.frames, { subtree: true, attributes: true, attributeFilter: ['class', 'src'] });
      this.resizeObserver = new ResizeObserver(() => this.fitScreen());
      this.resizeObserver.observe(this.frames.parentElement);
      this.fitScreen();
      this.syncModal();
    }
    fitScreen() {
      const stage = this.frames.parentElement;
      const size = Math.min(stage.clientWidth, stage.clientHeight);
      this.frames.style.width = `${size}px`;
      this.frames.style.height = `${size}px`;
    }
    syncModal() {
      const current = this.frames.querySelector('.is-current');
      const image = document.getElementById(this.dataset.modalId)?.querySelector(`img[data-media-id="${this.dataset.mediaId}"]`);
      if (image && current?.getAttribute('src')) {
        image.removeAttribute('srcset'); image.src = current.src; image.alt = current.alt;
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.resizeObserver?.disconnect(); }
  });
}
